// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-menu{height:100%;left:0;pointer-events:none;position:fixed;top:0;width:100%;z-index:9}.main-menu__bar{display:flex;flex-flow:row nowrap;height:72px;justify-content:flex-end;width:100%}.main-menu__burger{height:72px;padding:12px;width:72px}.main-menu__btn{cursor:pointer;pointer-events:auto}.main-menu__btn-text{clip:rect(0 0 0 0);border:0;margin:-1px;max-height:1px;max-width:1px;overflow:hidden;padding:0;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
